import { render } from "./PricesManagerSettingsStage.vue?vue&type=template&id=0d72a8d4"
import script from "./PricesManagerSettingsStage.vue?vue&type=script&lang=js"
export * from "./PricesManagerSettingsStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__